/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { FiPhoneCall } from 'react-icons/fi';
import { MyContext } from '../../Context/MyProvider';
import { BiSolidEditAlt } from "react-icons/bi";
import { showToast } from '../../showTost';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IoClose } from "react-icons/io5";
import { useTranslation } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";
import { readStoredObject } from '../../utils/storage';
import { dashboardPath } from '../../utils/routes';
import {
    LuBell,
    LuCalendarDays,
    LuCar,
    LuCircleHelp,
    LuCreditCard,
    LuFileText,
    LuGift,
    LuGlobe,
    LuHouse,
    LuLogOut,
    LuMessageCircle,
    LuPackage,
    LuPill,
    LuTag,
    LuWallet,
} from "react-icons/lu";

const menuIconClass = "text-[20px] shrink-0";

const MenuIconBubble = ({ active, children }) => (
    <div className={`bg-gray-200 rounded-[100%] p-[6px] ${active ? 'text-[#0d9488]' : 'text-[#28303F]'} group-hover:text-[#0d9488]`}>
        {children}
    </div>
);

const SaidMenu = ({ index }) => {

    const { t } = useTranslation();

    const { ImgBaseUrl, setIsLogin, ApiBaseUrl, setIsShow, setshowBox, isLogin, setShowMenu, MenuRef, activePage, setActivePage } = useContext(MyContext);

    const [pageList, setPageList] = useState([]);
    const [userImg, setUserImg] = useState("");
    const navigate = useNavigate();


    const LoginData = readStoredObject("Loginuser");
    var { name, country_code, phone } = LoginData || {};

    const HandleLogOut = () => {
        const Loginuser = secureLocalStorage.getItem("Loginuser");
        if (Loginuser) {
            showToast({ title: t("Logout Successful!"), id: "success" });
            navigate("/");
            setIsLogin("1");
            secureLocalStorage.clear();
            sessionStorage.clear();
        }
    };

    const HandleNavigate = (path, id) => {
        setActivePage(id);
        if (index === 1) {
            MenuRef.current.classList.remove('open');
            setShowMenu(false);
        }

        if (path === 0) {
            setIsShow(true);
            return;
        }
        
        navigate(dashboardPath(path));
    };

    useEffect(() => {
        const Loginuser = readStoredObject("Loginuser");
        if (Loginuser) {
            const { image } = Loginuser;
            if (image) {
                setUserImg(ImgBaseUrl + image);
            }
        }
    }, [isLogin]);

    useEffect(() => {
        axios.post(`${ApiBaseUrl}/customer/pages`)
            .then((res) => {
                setPageList(res.data.pages_data);
            })
            .catch((error) => {
                console.error(error);
            });

        const Page = sessionStorage.getItem("activepage");
        setActivePage(Number(Page));

    }, []);

    const HandleShowProfileBox = () => {
        setshowBox(true);
        MenuRef.current.classList.remove('open');
        setShowMenu(false);
    };

    const closeDrawerIfMobile = () => {
        if (index === 1) {
            MenuRef.current.classList.remove('open');
            setShowMenu(false);
        }
    };

    const renderRow = (key, onClick, pageId, label, Icon) => (
        <div key={key} onClick={onClick} className="flex items-center justify-between cursor-pointer py-[8px] group">
            <div className="flex items-center gap-[8px]">
                <MenuIconBubble active={activePage === pageId}>
                    <Icon className={menuIconClass} aria-hidden />
                </MenuIconBubble>
                <h1 className={`font-[500] ${activePage === pageId && "text-[#0d9488]"} group-hover:text-[#0d9488]`}>{label}</h1>
            </div>
            <FaChevronRight className={`${activePage === pageId ? "text-[#0d9488]" : "text-gray-300"} group-hover:text-[#0d9488]`} />
        </div>
    );

    return (
        <div className={`${index !== 1 ? "border-e-[2px] w-[265px]" : "w-[300px] max-_430_:w-[270px]"} border-[#8080803b] bg-white`} >
            <div className="px-[20px] pt-[10px] max-_430_:pb-[60px] h-[100%] scroll-container">

                {index === 1 && <button onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false) }} className='absolute right-[20px] top-[10px] z-[999]'><IoClose className='text-[25px]' /></button>}

                <div className="text-center border-b-[1px] border-[#8080803b] pb-[20px]">
                    <div className="relative mt-[10px]">
                        {userImg
                            ? <img src={userImg} className='w-[90px] h-[90px] rounded-[100%] mx-auto' alt="" />
                            : <div className='bg-[#F3F4F6] w-[90px] h-[90px] rounded-[100%] flex items-center justify-center mx-auto'>
                                <h1 className='text-[#0d9488] font-[500] text-[20px]'>{name?.charAt(0).toUpperCase()}</h1>
                            </div>}
                        <button onClick={HandleShowProfileBox} className="bg-[#0d9488] inline-block rounded-[100%] p-[3px] border-[2px] border-white absolute -mt-[20px] ms-[15px]"><BiSolidEditAlt className='text-white text-[13px]' /></button>
                    </div>
                    <h1 className='font-[500] text-[17px] mt-[7px]'>{name}</h1>
                    <div className="flex items-center gap-[5px] justify-center text-[15px]">
                        <FiPhoneCall />
                        <h1>{country_code} {phone}</h1>
                    </div>
                </div>

                <div className="mt-[20px] scroll-container">
                    {renderRow("booking", () => HandleNavigate("/booking", 1), 1, t("My Booking"), LuCalendarDays)}
                    {renderRow("order", () => HandleNavigate("/order", 2), 2, t("My Order"), LuTag)}
                    {renderRow("package", () => HandleNavigate("/booking-package", 3), 3, t("Booking Package"), LuPackage)}
                    {renderRow("medicine-reminder", () => HandleNavigate("/medicine-reminder", 13), 13, "Medicine Reminder", LuPill)}
                    {renderRow("health-records", () => HandleNavigate("/health-records", 19), 19, "Health Records", LuFileText)}
                    {renderRow("digital-card", () => HandleNavigate("/digital-card", 14), 14, "Digital Health Pass", LuCreditCard)}
                    {renderRow("home-care", () => { setActivePage(15); closeDrawerIfMobile(); navigate('/home-care/bookings'); }, 15, "Home Care", LuHouse)}
                    {renderRow("home-visit", () => { setActivePage(16); closeDrawerIfMobile(); navigate('/home-visit/bookings'); }, 16, "Home Visit", LuCar)}
                    {renderRow("pay-app", () => { setActivePage(17); closeDrawerIfMobile(); navigate('/pay-app/history'); }, 17, "Pay via App", LuCreditCard)}
                    {renderRow("notifications", () => HandleNavigate("/notifications", 18), 18, "Notifications", LuBell)}
                    {renderRow("wallet", () => HandleNavigate("/wallet", 4), 4, t("Wallet"), LuWallet)}
                    {renderRow("refer", () => HandleNavigate("/refer-and-earn", 5), 5, t("Refer & Earn"), LuGift)}
                    {renderRow("language", () => HandleNavigate(0, 6), 6, t("Language"), LuGlobe)}
                    {renderRow("chat", () => HandleNavigate("/chat", 7), 7, t("Chat"), LuMessageCircle)}
                    {renderRow("faq", () => HandleNavigate("/faq", 12), 12, t("FAQs"), LuCircleHelp)}

                    {pageList.map((item, pageIndex) => {
                        const Title = item.title.replace(/\s+/g, '_');
                        const FinalText = Title.toLowerCase();
                        const pageId = pageIndex + 8;

                        return renderRow(
                            `page-${FinalText}`,
                            () => HandleNavigate(`/${FinalText}`, pageId),
                            pageId,
                            item.title,
                            LuFileText
                        );
                    })}

                    <div onClick={HandleLogOut} className="flex items-center justify-between cursor-pointer py-[8px] group">
                        <div className="flex items-center gap-[8px]">
                            <MenuIconBubble active={false}>
                                <LuLogOut className={menuIconClass} aria-hidden />
                            </MenuIconBubble>
                            <h1 className='font-[500] group-hover:text-[#0d9488]'>{t("Log Out")}</h1>
                        </div>
                        <FaChevronRight className='text-gray-300 group-hover:text-[#0d9488]' />
                    </div>
                </div>

            </div>
        </div >
    )
}
export default SaidMenu
/* jshint ignore:end */
